// @flow

export const dateFormatSettings = {
  'd MMM, yyyy': 'j M, Y',
  'd MMMM yyyy': 'j F Y',
  'dd MMMM yyyy': 'd F Y',
  'MM/dd/yyyy': 'm/d/Y',
  'MMMM d, yyyy': 'F j, Y',
  'dd/MM/yyyy': 'd/m/Y',
  'dd.MM.yyyy': 'd.m.Y',
  'yyyy-MM-dd': 'Y-m-j'
};

export const timeFormatSettings = {
  'h:mm a-no-minutes': 'g A',
  'h:mm a': 'g:i A',
  'H:mm-no-minutes': 'H:i',
  'H:mm': 'H:i'
};
